export default {
  entity: {
    entities: {
      type: Array,
      default: () => []
    },
    entityWidth: {
      type: [Number, String],
      default: 200,
      validate: validateNumber
    },
    entityHeight: {
      type: [Number, String],
      default: null,
      validate: validateNumber
    },
    entityId: {
      type: String,
      default: 'id'
    },
    eventEntityId: {
      type: String,
      default: 'entity_id'
    },
    entityFormat: {
      type: Function,
      default: null
    },
    showEntityLabel: {
      type: Function,
      default: null
    },
    selectedDays: {
      type: Array,
      default: () => []
    },
    requestedVacations: {
      type: Array,
      default: () => []
    },
    selectedDayEntityId: {
      type: String,
      default: 'entity_id'
    },
    selectedDayDate: {
      type: String,
      default: 'date'
    },
    paddingDay: {
      type: [Number, String],
      default: null,
      validate: validateNumber
    },
    holidays: {
      type: Array,
      default: () => []
    }
  }
};

export function validateNumber(input) {
  return isFinite(parseInt(input));
}
